const services = [
  {
    icon: 'ri-tools-line',
    title: 'Standard Grinding',
    description: 'Deep grinding 6-8 inches below grade to completely eliminate stumps and restore your yard\'s beauty. Our precision equipment ensures thorough removal, allowing you to replant grass or landscaping immediately.'
  },
  {
    icon: 'ri-plant-line',
    title: 'Root Pruning',
    description: 'Professional removal of surface roots to prevent mower damage and restore smooth, safe lawn surfaces. We carefully eliminate protruding roots while preserving your landscape\'s integrity and aesthetic appeal.'
  },
  {
    icon: 'ri-star-line',
    title: 'Premium Cleanup',
    description: 'Complete restoration service including mulch haul-away and topsoil backfill. We leave your yard pristine and ready for immediate use, transforming the stump site into a seamless part of your beautiful landscape.'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full mb-4">
            OUR SERVICES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Stump Grinding Services
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Professional stump grinding solutions tailored to your needs. We combine quality equipment with exceptional customer service to restore your yard's beauty and deliver outstanding results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group flex flex-col"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-emerald-50 rounded-full mb-6 group-hover:bg-emerald-100 transition-colors">
                <i className={`${service.icon} text-3xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow">
                {service.description}
              </p>
              <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700 group-hover:gap-3 transition-all cursor-pointer">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
